const SearchActionType = {
    SEARCH_REQUEST:'SEARCH_REQUEST',
    SEARCH_SUCCESS:'SEARCH_SUCCESS',
    SEARCH_FAIL:'SEARCH_FAIL',
}


export default SearchActionType